import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdCheckbox } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheckCircle, MdHome, MdLightMode, MdLocationPin, MdSearch } from "react-icons/md";

import OneObjective from "./OneObjective";

import banner1 from '../assets/staff.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import bg from '../assets/bg.jpg';
import logo from '../assets/logo.png';

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
				}}
			>

					<div
						style={{
							backgroundImage: `url(${banner1})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							backgroundRepeat: 'no-repeat',
							height: '50vh',
							position: "relative"
						}}
					>
						<div
							style={{
							position: "absolute",
							left:0,
							bottom:0
						}}
						>
							<h1 className="text-light font-bold px-5 py-3">ABOUT US</h1>
						</div>
					</div>
					<div className="bg-extra p-5">
						<h6>
							We are the Foundation for Poverty Alleviation and Development Initiatives (FPADI), a non-governmental organization dedicated to empowering Tanzanian communities with knowledge and skills to achieve sustainable economic development.
							<br/><br/>
							Our focus is on environmental protection and climate change advocacy, women and youth empowerment, and sustainable agriculture that will lead to sustainable livelihoods.
							<br/><br/>
							Westrive to eradicate poverty and promote social inclusion through building capacities and advocating for good governance. We believe that with the right tools, knowledge, and support, communities can overcome poverty and achieve sustainable livelihoods. Join us in our mission to create a prosperous future for all
							<br/><br/>
							We were officially registered in January 2022, under the Non-Governmental Organization Act, 2002 made under Section 11(1) and 17(2) of Act No.24 of 2002.
						</h6>
					</div>

				<div 
					className="MainBodySection" 
					style={{
						backgroundImage: `url(${bg})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						backgroundRepeat: 'no-repeat',
						overflow:"hidden"
					}}
				>
					<div 
						className="row pt-3 pb-5"
						
					>

						<div className="col-md-12 mt-5 px-5 text-center">
							<img src={logo} height={200}/>
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center text-secondary font-bold mt-5 mb-2"
							>
								OUR MOTTO
							</h6>

							<h6
								style={{
									fontSize: "16px",
								}}
								className="font-semi-bold text-center px-5"
							>
								We strive to become and remain an impact-driven organization for community development. Our goal is to achieve this through sustainable and all inclusive development initiatives that effectively alleviate poverty				
							</h6>
							
						</div>

						<div className="col-md-12 mt-5 px-5">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center text-secondary font-bold mt-3 mb-2"
							>
								OUR VISION
							</h6>

							<h6
								style={{
									fontSize: "16px",
								}}
								className="font-semi-bold text-center px-5"
							>
								FPADI’s vision is to transform community life into a quality and sustainable living experience.						
							</h6>
							
						</div>

						<div className="col-md-12 mt-5 px-5">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center text-secondary font-bold mt-3 mb-2"
							>
								OUR MISSION
							</h6>

							<h6
								style={{
									fontSize: "16px",
								}}
								className="font-semi-bold text-center px-5"
							>
								Our mission is to empower communities socially and economically through environmentally friendly agriculture, the empowerment of women and youth, inclusive practices, capacity building, and good governance. Through these efforts, we aim to improve living standards and reduce poverty.
							</h6>
							
						</div>
					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}